"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrivacyPolicy() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.1,
    once: true
  });
  return <section id="privacy-policy" data-nav="light" ref={sectionRef} className="bg-background text-foreground py-16 md:py-20 border-b border-border">
      <div className="max-w-[1136px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          <div className={`md:col-start-3 md:col-span-8 transition-opacity duration-700 ease-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
            {/* Header Block */}
            <div className="mb-10">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground font-default mb-4">
                Privacy Policy
              </h1>

              <div className="flex items-center gap-3">
                <span className="text-sm font-medium text-muted-foreground">
                  Last Updated: January 2025
                </span>
                {/* Signature hairline rule capped with a crisp turquoise terminal dot */}
                <div className="flex-1 flex items-center gap-1.5" aria-hidden="true">
                  <div className="h-px bg-border flex-1" />
                  <div className="size-2 rounded-full bg-primary shrink-0" />
                </div>
              </div>
              <p className="text-sm font-medium text-muted-foreground mt-1">
                Operator: Ahmed Kamal Hussein Abdel-Aal.
              </p>
            </div>

            {/* Continuous Legal Text */}
            <div className="space-y-8 text-foreground/90 font-default text-base leading-relaxed">
              <p className="text-lg text-foreground font-normal leading-relaxed">
                Hurghada Transfer Hub (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;) respects your privacy and is dedicated to protecting the personal information you share when using our website and private transfer services across Egypt.
              </p>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  Information We Collect
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  When you request a transfer or contact us, we collect necessary personal details including your name, email address, WhatsApp or telephone number, flight details, pickup location, and destination resort. This information is gathered solely to coordinate and fulfill your private transportation.
                </p>
              </div>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  How We Use Your Information
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  We use collected details (including flight details) to confirm reservations, follow the arrival time and any delays of your flight, send pickup details via WhatsApp or email, and ensure our driver meets you at the agreed meeting time. We do not sell, rent, or trade your personal information to third parties.
                </p>
              </div>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  Data Storage and Security
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  Your booking details are stored on secure internal databases accessible only to authorized dispatch personnel. We employ strict administrative safeguards to prevent unauthorized data access or disclosure.
                </p>
              </div>

              <div className="border-t border-border/80 pt-6">
                <h2 className="text-xl font-semibold text-foreground mb-3 tracking-tight">
                  Your Rights
                </h2>
                <p className="text-muted-foreground leading-relaxed">
                  You may request review, modification, or deletion of your stored booking data at any time by contacting our privacy compliance desk at{" "}
                  <a href="mailto:info@hurghadatransferhub.com" className="text-primary hover:text-primary/80 font-medium underline underline-offset-4 decoration-primary/40 transition-colors">
                    info@hurghadatransferhub.com
                  </a>{" "}
                  or via WhatsApp at{" "}
                  <a href="tel:+201010634627" className="text-primary hover:text-primary/80 font-medium underline underline-offset-4 decoration-primary/40 transition-colors">
                    +20 10 10634627
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}